/**
 * PartnerIcons.jsx
 * Created by Destin Frasier on 10/23/17.
 */

import PartnerIconSingleton from './partnerIconSingleton';
import BaseIcon from '../BaseIcon';


class PartnerIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = PartnerIconSingleton;
    }
}

export class NationalArchives extends PartnerIcon {}
NationalArchives.defaultProps = {
    iconName: 'rec-icon-national-archives',
    iconClass: 'rec-icon-national-archives',
    alt: 'National Archives'
};

export class NationalArchivesColor extends PartnerIcon {}
NationalArchivesColor.defaultProps = {
    iconName: 'rec-icon-national-archives-color',
    iconClass: 'rec-icon-national-archives-color',
    alt: 'National Archives'
};

export class DOI extends PartnerIcon {}
DOI.defaultProps = {
    iconName: 'rec-icon-doi',
    iconClass: 'rec-icon-doi',
    alt: 'Bureau of Reclamation'
};

export class DOIColor extends PartnerIcon {}
DOIColor.defaultProps = {
    iconName: 'rec-icon-doi-color',
    iconClass: 'rec-icon-doi-color',
    alt: 'Bureau of Reclamation'
};

export class TVA extends PartnerIcon {}
TVA.defaultProps = {
    iconName: 'rec-icon-tva',
    iconClass: 'rec-icon-tva',
    alt: 'Tennessee Valley Authority'
};

export class TVAColor extends PartnerIcon {}
TVAColor.defaultProps = {
    iconName: 'rec-icon-tva-color',
    iconClass: 'rec-icon-tva-color',
    alt: 'Tennessee Valley Authority'
};

export class TRE extends PartnerIcon {}
TRE.defaultProps = {
    iconName: 'rec-icon-tre',
    iconClass: 'rec-icon-tre',
    alt: 'Deptartment of The Treasury'
};

export class TREColor extends PartnerIcon {}
TREColor.defaultProps = {
    iconName: 'rec-icon-tre-color',
    iconClass: 'rec-icon-tre-color',
    alt: 'Deptartment of The Treasury'
};

export class NPS extends PartnerIcon {}
NPS.defaultProps = {
    iconName: 'rec-icon-nps',
    iconClass: 'rec-icon-nps',
    alt: 'National Park Service'
};

export class NPSColor extends PartnerIcon {}
NPSColor.defaultProps = {
    iconName: 'rec-icon-nps-color',
    iconClass: 'rec-icon-nps-color',
    alt: 'National Park Service'
};

export class USACE extends PartnerIcon {}
USACE.defaultProps = {
    iconName: 'rec-icon-usace',
    iconClass: 'rec-icon-usace',
    alt: 'Army Corps of Engineers'
};

export class USACEColor extends PartnerIcon {}
USACEColor.defaultProps = {
    iconName: 'rec-icon-usace-color',
    iconClass: 'rec-icon-usace-color',
    alt: 'Army Corps of Engineers'
};

export class ForestService extends PartnerIcon {}
ForestService.defaultProps = {
    iconName: 'rec-icon-forest-service',
    iconClass: 'rec-icon-forest-service',
    alt: 'Forest Service'
};

export class ForestServiceColor extends PartnerIcon {}
ForestServiceColor.defaultProps = {
    iconName: 'rec-icon-forest-service-color',
    iconClass: 'rec-icon-forest-service-color',
    alt: 'Forest Service'
};

export class NOAA extends PartnerIcon {}
NOAA.defaultProps = {
    iconName: 'rec-icon-noaa',
    iconClass: 'rec-icon-noaa',
    alt: 'National Oceanic and Atmospheric Administration'
};

export class NOAAColor extends PartnerIcon {}
NOAAColor.defaultProps = {
    iconName: 'rec-icon-noaa-color',
    iconClass: 'rec-icon-noaa-color',
    alt: 'National Oceanic and Atmospheric Administration'
};

export class BLM extends PartnerIcon {}
BLM.defaultProps = {
    iconName: 'rec-icon-blm',
    iconClass: 'rec-icon-blm',
    alt: 'Bureau of Land Management'
};

export class BLMColor extends PartnerIcon {}
BLMColor.defaultProps = {
    iconName: 'rec-icon-blm-color',
    iconClass: 'rec-icon-blm-color',
    alt: 'Bureau of Land Management'
};

export class Smithsonian extends PartnerIcon {}
Smithsonian.defaultProps = {
    iconName: 'rec-icon-smithsonian',
    iconClass: 'rec-icon-smithsonian',
    alt: 'Smithsonian'
};

export class SmithsonianColor extends PartnerIcon {}
SmithsonianColor.defaultProps = {
    iconName: 'rec-icon-smithsonian-color',
    iconClass: 'rec-icon-smithsonian-color',
    alt: 'Smithsonian'
};

export class FWS extends PartnerIcon {}
FWS.defaultProps = {
    iconName: 'rec-icon-fws',
    iconClass: 'rec-icon-fws',
    alt: 'Fish & Wildlife'
};

export class FWSColor extends PartnerIcon {}
FWSColor.defaultProps = {
    iconName: 'rec-icon-fws-color',
    iconClass: 'rec-icon-fws-color',
    alt: 'Fish & Wildlife'
};

export class DOT extends PartnerIcon {}
DOT.defaultProps = {
    iconName: 'rec-icon-dot',
    iconClass: 'rec-icon-dot',
    alt: 'Department of Transportation'
};

export class DOTColor extends PartnerIcon {}
DOTColor.defaultProps = {
    iconName: 'rec-icon-dot-color',
    iconClass: 'rec-icon-dot-color',
    alt: 'Department of Transportation'
};
